import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

export type PaymentsDialogStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const usePaymentsDialogStore = create<PaymentsDialogStore>()(
  immer((set) => ({
    isOpen: false,
    setIsOpen: (isOpen: boolean) =>
      set((state) => {
        state.isOpen = isOpen;
      }),
  })),
);
